// Timestamps are UTC from the API and shown in Manila time (design doc §2.6).
const DAY = new Intl.DateTimeFormat("en-PH", { timeZone: "Asia/Manila", day: "numeric", month: "short", year: "numeric" });
// A calendar date with no time ("2026-10-05") is already Manila's day: read it as is.
const DATE = new Intl.DateTimeFormat("en-PH", { timeZone: "UTC", weekday: "short", day: "numeric", month: "short" });
const MOMENT = new Intl.DateTimeFormat("en-PH", { timeZone: "Asia/Manila", day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });

/** "27 Sept 2026" */
export const formatDay = (iso: string) => DAY.format(new Date(iso));

/** "2026-10-05" → "Mon, 5 Oct" */
export const formatDate = (date: string) => DATE.format(new Date(`${date}T00:00:00Z`));

/** "27 Sept, 2:05 PM" */
export const formatMoment = (iso: string) => MOMENT.format(new Date(iso));

const MANILA_PARTS = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hourCycle: "h23", weekday: "short" });

/** Now in Manila: the calendar date ("2026-10-05"), the hour (0–23) and whether it's a Sunday. */
export function manilaNow(at = new Date()) {
  const part = (type: string) => MANILA_PARTS.formatToParts(at).find((p) => p.type === type)?.value ?? "";
  return { date: `${part("year")}-${part("month")}-${part("day")}`, hour: Number(part("hour")), sunday: part("weekday") === "Sun" };
}
